import tw, { styled } from 'twin.macro';

export const Content = styled.div`
  ${tw`flex flex-col flex-grow`};
`;
